import axios from "axios";

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_NICE_AUTH_API,
  withCredentials: true,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
  },
  timeout: 50000, // request timeout 50s
});

export default service;
